import { render, staticRenderFns } from "./DefaultTable.vue?vue&type=template&id=2fa9f269&scoped=true&"
import script from "./DefaultTable.vue?vue&type=script&lang=js&"
export * from "./DefaultTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa9f269",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa9f269')) {
      api.createRecord('2fa9f269', component.options)
    } else {
      api.reload('2fa9f269', component.options)
    }
    module.hot.accept("./DefaultTable.vue?vue&type=template&id=2fa9f269&scoped=true&", function () {
      api.rerender('2fa9f269', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/modules/JEditableTable/DefaultTable.vue"
export default component.exports